import React from 'react';
import { motion } from 'framer-motion';
import { ActivityIcon, ZapIcon, DollarSignIcon, TimerIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function PerformanceSlide() {
  return <SlideLayout data-id="element-316">
      <motion.div variants={itemVariants} className="mb-16 text-center" data-id="element-317">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-318">
          Faster and Cheaper —{' '}
          <span className="text-brand-text-muted" data-id="element-319">Not a Tradeoff</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-320">
        {/* KPI 1 */}
        <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8 relative overflow-hidden group hover:border-brand-teal/50 transition-colors" data-id="element-321">
          <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-322">
            <ActivityIcon className="w-24 h-24 text-brand-teal" data-id="element-323" />
          </div>
          <div className="relative z-10" data-id="element-324">
            <div className="text-5xl md:text-6xl font-bold text-brand-teal tracking-tighter mb-4" data-id="element-325">
              5k-10k
            </div>
            <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-326">
              Tokens / Second
            </h3>
            <p className="text-brand-text-dim" data-id="element-327">
              Throughput target for Llama 8B. Potentially faster than most GPU
              endpoints for this model class.
            </p>
          </div>
        </motion.div>

        {/* KPI 2 */}
        <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8 relative overflow-hidden group hover:border-brand-teal/50 transition-colors" data-id="element-328">
          <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-329">
            <TimerIcon className="w-24 h-24 text-brand-teal" data-id="element-330" />
          </div>
          <div className="relative z-10" data-id="element-331">
            <div className="text-5xl md:text-6xl font-bold text-brand-teal tracking-tighter mb-4" data-id="element-332">
              &lt;100<span className="text-3xl" data-id="element-333">ms</span>
            </div>
            <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-334">
              Time-to-First-Token
            </h3>
            <p className="text-brand-text-dim" data-id="element-335">
              Llama 70B latency reduced from ~300ms. The difference between
              fluid and broken for real-time apps.
            </p>
          </div>
        </motion.div>

        {/* KPI 3 */}
        <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8 relative overflow-hidden group hover:border-brand-teal/50 transition-colors" data-id="element-336">
          <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-337">
            <ZapIcon className="w-24 h-24 text-brand-teal" data-id="element-338" />
          </div>
          <div className="relative z-10" data-id="element-339">
            <div className="text-4xl md:text-5xl font-bold text-brand-teal tracking-tighter mb-4" data-id="element-340">
              Near-Zero
            </div>
            <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-341">
              Latency Jitter
            </h3>
            <p className="text-brand-text-dim" data-id="element-342">
              Deterministic FPGA execution eliminates variance spikes. Every
              request lands within a tight latency band.
            </p>
          </div>
        </motion.div>

        {/* KPI 4 */}
        <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8 relative overflow-hidden group hover:border-brand-teal/50 transition-colors" data-id="element-343">
          <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-344">
            <DollarSignIcon className="w-24 h-24 text-brand-teal" data-id="element-345" />
          </div>
          <div className="relative z-10" data-id="element-346">
            <div className="text-4xl md:text-5xl font-bold text-brand-teal tracking-tighter mb-4" data-id="element-347">
              Lowest $/M
            </div>
            <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-348">
              Cost per Token
            </h3>
            <p className="text-brand-text-dim" data-id="element-349">
              Talk to us about how we can get you the lowest cost while
              exceeding your latency goals.
            </p>
          </div>
        </motion.div>
      </div>

      <motion.div variants={itemVariants} className="text-center max-w-3xl mx-auto" data-id="element-350">
        <p className="text-brand-text-muted bg-brand-bg-card/50 py-3 px-6 rounded-full border border-brand-border inline-block" data-id="element-351">
          <span className="text-brand-text font-medium" data-id="element-352">The Tradeoff:</span>{' '}
          Where throughput exceeds requirements, we parallelize to trade excess
          speed for even lower per-token cost.
        </p>
      </motion.div>
    </SlideLayout>;
}